module.exports = __webpack_public_path__ + "static/react-cd54cebd38bc2195da1475eb65f64257.jpg";